'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class CustomSwitch extends _react.PureComponent {
  state = {
    id: String(++app.form_index)
  };
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: [true, 'true'].includes(props['default-value']),
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    props.onChange({
      e: e,
      value: e.target.checked,
      name: props.name
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let class_name = props.className || '';
    if (![false, 'false'].includes(props['full-width'])) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    class_name += ' mui-switch';
    const checked = [true, 'true'].includes(props.value);
    let output = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props['top-label'] ? /*#__PURE__*/_react.default.createElement("label", {
      className: "switch-label top u-no-select",
      htmlFor: state.id
    }, props['top-label']) : undefined, /*#__PURE__*/_react.default.createElement("div", {
      className: class_name
    }, props['left-label'] ? /*#__PURE__*/_react.default.createElement("label", {
      className: "switch-label left u-no-select",
      htmlFor: props.label ? checked ? state.id : undefined : state.id
    }, props['left-label']) : undefined, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      checked: checked,
      onChange: component.handleChange,
      name: props.name,
      color: "primary",
      className: props['switch-class'],
      style: {
        height: 'auto'
      },
      id: state.id,
      disabled: props['read-only'] === true
    }), props.label ? /*#__PURE__*/_react.default.createElement("label", {
      className: "switch-label right u-no-select",
      htmlFor: props['left-label'] ? checked ? undefined : state.id : state.id
    }, props.label) : undefined));
    return output;
  }
}
exports.default = CustomSwitch;
